import { withDependencies, named } from '@wix/thunderbolt-ioc'
import { IFontsLoadingState } from './types'
import { name } from './symbols'
import { FeatureStateSymbol } from '@wix/thunderbolt-symbols'

export const FontsLoadingState = withDependencies(
	[named(FeatureStateSymbol, name)],
	(featureState: IFontsLoadingState): IFontsLoadingState => {
		return featureState
	}
)
